import React, { useRef } from "react";

// Invisible spam protection: a hidden honeypot field + time-to-fill. Spread guard() into the POST body.
export function useSpamGuard() {
  const start = useRef(Date.now());
  const hp = useRef(null);
  const honeypot = (
    <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", top: "auto", width: 1, height: 1, overflow: "hidden" }}>
      <label>
        Leave this field empty
        <input ref={hp} type="text" name="website" tabIndex={-1} autoComplete="off" defaultValue="" />
      </label>
    </div>
  );
  const guard = () => ({ hp: hp.current?.value || "", elapsed_ms: Date.now() - start.current });
  return { honeypot, guard };
}
